<template>
  <div class="templates-menu">
    <main-logo
      class="logo"
      width="66px"
      height="21px"
    />
    <div>
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'TemplatesMenu',
};
</script>

<style lang="scss" scoped>
.templates-menu{
    padding: 0 0.5rem;
    border-bottom: solid 1px #222;
    display: flex;
    height: 40px;
    margin-top: -60px;
    align-items: center;
    justify-content: space-between;
}
.logo{
    opacity: 0.5;
}
.logo::v-deep svg{
    fill: white;
}
</style>
